module.exports = __webpack_public_path__ + "img/Big.983299e4.png";